import logo from "../assets/kosmos-logo.png";
import cock from "../assets/cock.png";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoCloseSharp } from "react-icons/io5";

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const StickyHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("/");
  const location = useLocation();

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  const getLinkStyle = (path) => ({
    textDecoration: "none",
    color: "black",
    paddingBottom: "2px",
    borderBottom: activeLink === path ? "2px solid #D3751D" : "none",
  });

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-transparent py-4 px-4 md:px-12">
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-between bg-white w-[55%] md:w-[75%] lg:w-[80%] xl:w-[85%] rounded-2xl px-4 lg:px-20 py-2 md:py-3 shadow-xl">
          <div className="bg-black p-1 rounded">
  <Link to="/" onClick={() => setActiveLink("/")}>
    <img
      src={logo}
      alt="Logo"
      className="w-6 h-6 md:w-10 md:h-10 object-contain"
    />
  </Link>
</div>


          <nav className="hidden lg:flex gap-12 text-black font-league text-[12px] lg:text-[18px] xl:text-[28px] tracking-wide uppercase">
            <Link
              to="/"
              onClick={() => setActiveLink("/")}
              style={getLinkStyle("/")}
            >
              Home
            </Link>
            <Link
              to="/registration"
              onClick={() => setActiveLink("/registration")}
              style={getLinkStyle("/registration")}
            >
              Registration Form
            </Link>
            <a
              href="#otheractivities"
              onClick={() => setActiveLink("#otheractivities")}
              style={{
                textDecoration: "none",
                color: "black",
                paddingBottom: "2px",
                borderBottom:
                  activeLink === "#otheractivities"
                    ? "border 2px solid #D3751D"
                    : "none",
              }}
            >
              Other Activities
            </a>

            <Link
              to="/contactus"
              onClick={() => setActiveLink("/contactus")}
              style={getLinkStyle("/contactus")}
            >
              Contact Us
            </Link>
          </nav>

          <div
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-black cursor-pointer"
          >
            {isOpen ? (
              <IoCloseSharp className="w-6 h-6" />
            ) : (
              <RxHamburgerMenu className="w-6 h-6" />
            )}
          </div>
        </div>

        <Link to="/slotpage" className="no-underline">
          <div className="bg-white border-none rounded-2xl px-4 py-4 md:px-4 md:py-6 flex items-center gap-2 text-black font-league text-[13px] md:text-[18px] xl:text-[24px] transition shadow-2xl">
            <img src={cock} alt="cock" className="w-4 h-4 md:w-6 md:h-6" />
            BOOK YOUR SLOT
          </div>
        </Link>
      </div>

      {isOpen && (
        <div className="flex flex-col lg:hidden mt-2 bg-white rounded-xl px-4 py-3 md:px-6 md:py-4 text-black font-league text-[18px] tracking-wide space-y-3 shadow-lg">
          <Link
            to="/"
            onClick={() => {
              setIsOpen(false);
              setActiveLink("/");
            }}
            style={getLinkStyle("/")}
          >
            Home
          </Link>
          <Link
            to="/registration"
            onClick={() => {
              setIsOpen(false);
              setActiveLink("/registration");
            }}
            style={getLinkStyle("/registration")}
          >
            Registration Form
          </Link>
          <a
            href="#otheractivities"
            onClick={() => {
              setIsOpen(false);
              setActiveLink("#otheractivities");
            }}
            style={{
              textDecoration: "none",
              color: "black",
              paddingBottom: "2px",
              display: "inline-block",
              borderBottom:
                activeLink === "#otheractivities"
                  ? "2px solid #D3751D"
                  : "none",
            }}
          >
            Other Activities
          </a>
          <Link
            to="/contactus"
            onClick={() => {
              setIsOpen(false);
              setActiveLink("/contactus");
            }}
            style={getLinkStyle("/contactus")}
          >
            Contact Us
          </Link>
        </div>
      )}
    </div>
  );
};

export default StickyHeader;
